export default {
  // The form, shared by the invite link and the portal
  title: 'Confirm your details',
  introInvite: '{company} needs these details before you start. It takes about two minutes.',
  introPortal: 'Before you carry on, {company} needs you to confirm your details.',
  sectionAbout: 'About you',
  sectionEmergency: 'Emergency contact',
  sectionEmergencyHint: 'Someone we can call if something happens to you at work.',
  sectionTax: 'Tax',
  sectionTaxHint: 'From your tax file number declaration. It is stored encrypted, and only the last three digits are ever shown.',
  sectionSuper: 'Super',
  sectionAbn: 'Business details',
  sectionAbnHint: "You work as a contractor, so we need your ABN instead of a tax file number and super fund.",
  email: 'Email',
  mobile: 'Mobile number',
  homeAddress: 'Home address',
  dateOfBirth: 'Date of birth',
  contactName: 'Full name',
  contactRelationship: 'Relationship',
  contactRelationshipPlaceholder: 'e.g. Partner, Parent',
  contactDaytimePhone: 'Phone',
  contactAfterHours: 'After-hours mobile (optional)',
  contactPhoneHint: 'Give at least one number.',
  tfn: 'Tax file number',
  tfnOnFile: 'On file: {value}. Leave blank to keep it.',
  noTfn: "I don't have a tax file number yet",
  noTfnReason: 'Why not?',
  noTfnReasonPlaceholder: 'e.g. Applied, waiting on the ATO',
  taxResident: 'I am an Australian resident for tax purposes',
  taxFreeThreshold: 'Claim the tax-free threshold from {company}',
  helpDebt: 'I have a HELP, VSL, SFSS or TSL debt',
  fundType: 'Type of fund',
  fundRegulated: 'Regulated (APRA) fund',
  fundSmsf: 'Self-managed super fund',
  fundName: 'Fund name',
  usi: 'USI (optional)',
  fundAbn: 'Fund ABN',
  memberNumber: 'Member number',
  memberOnFile: 'On file: {value}. Leave blank to keep it.',
  abn: 'ABN',
  privacyNote: 'Your tax file number and member number are encrypted when stored and are never shown in full again.',
  payNotConfigured: "{company}'s CrewPresence can't store tax details yet. Let your manager know. You can carry on once they've fixed it.",
  submit: 'Confirm my details',
  submitting: 'Saving…',
  saved: 'Thanks, your details are saved.',

  // The portal page someone is held at
  portalHeading: 'One more thing before you start',
  signOut: 'Sign out',

  // Admin: who still has to confirm, and asking
  badge: 'Details incomplete',
  badgeHint: "Asked to confirm their employment details and hasn't yet.",
  request: 'Request details',
  requestTitle: 'Ask for employment details',
  requestDescription: 'Each person you pick has to confirm their contact, emergency contact, tax and super details. Anyone whose phone is already set up is asked in the app. Everyone else is emailed a link.',
  requestNobody: 'Everyone has confirmed their details.',
  requestSelectAll: 'Select everyone',
  requestSelect: 'Request details from {name}',
  requestInApp: 'Asked in the app',
  requestEmail: 'Emailed a link',
  requestNoEmail: 'No email address, so no link can be sent',
  requestAlreadyAsked: 'Already asked',
  requestSubmit: 'Request details',
  requestSubmitOne: 'Request details from {count} person',
  requestSubmitOther: 'Request details from {count} people',
  requesting: 'Sending…',
  requestResult: 'Asked {requested} of {selected}, and emailed {emailed} a link.',
  requestResultNone: 'Nobody needed asking.',
  requestFailedHeading: 'Not emailed',
}
